import { UserContactInfoApiType } from '@/api/models/common/lib/common.types'

type ProfileDocument = {
  label: string
  linkKey: Extract<
    keyof UserContactInfoApiType,
    'agreementLink' | 'consentLink' | 'privacyLink' | 'promoLink'
  >
}

export const PROFILE_DOCUMENTS: ProfileDocument[] = [
  {
    label: 'Пользовательское соглашение',
    linkKey: 'agreementLink'
  },
  {
    label: 'Согласие на обработку персональных данных',
    linkKey: 'consentLink'
  },
  {
    label: 'Политика конфиденциальности',
    linkKey: 'privacyLink'
  },
  {
    label: 'Согласие на получение рекламных сообщений',
    linkKey: 'promoLink'
  }
]
